/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import { useQuery } from '@apollo/client' // Npm: Apollo client for handling graphql request.
import { useDispatch } from 'react-redux' // Npm: Redux dispatch hook.


/*
 * GRAPHS
 */
import SystemInformationRemoteReadQuery from './__query__/remote.systemInformation.read.query'
import SystemInformationReadUniqueQuery from './__query__/local.systemInformation.read.query'


/*
 * CONSTANTS
 */


/*
 *  Handles Remote System Polling (DB Server)
 */
const RemoteSystemPollingHandler = () => {
  // Hook assignment.
  const dispatch = useDispatch()
  const _QueryRemoteSystemInformation = useQuery(SystemInformationRemoteReadQuery, {
    'fetchPolicy': Object.React.App.fetchPolicy,
    'pollInterval': 20000
  })

  // Update Redux whenever polling returns fresh remote system data.
  React.useEffect(() => {
    if (_QueryRemoteSystemInformation.error) {
      dispatch({
        'type': 'SYSTEMINFO_REMOTE_ERROR',
        'payload': _QueryRemoteSystemInformation.error
      })
    } else if (_QueryRemoteSystemInformation.data?.SystemInformationRemoteRead) {
      dispatch({
        'type': 'SYSTEMINFO_REMOTE_UPDATE',
        'payload': _QueryRemoteSystemInformation.data.SystemInformationRemoteRead
      })
    }
  }, [_QueryRemoteSystemInformation.data, _QueryRemoteSystemInformation.error, dispatch])

  // Return null as this is just a handler.
  return null
}


/*
 *  Handles Local System Polling (Node Server)
 */
const LocalSystemPollingHandler = () => {
  // Hook assignment.
  const dispatch = useDispatch()
  const _QueryLocalSystemInformation = useQuery(
    SystemInformationReadUniqueQuery,
    {
      fetchPolicy: Object.React.App.fetchPolicy,
      // 'pollInterval': 20000
    },
  );

  // Update Redux whenever polling returns fresh local system data.
  React.useEffect(() => {
    if (_QueryLocalSystemInformation.error) {
      dispatch({
        'type': 'SYSTEMINFO_LOCAL_ERROR',
        'payload': _QueryLocalSystemInformation.error
      })
    } else if (_QueryLocalSystemInformation.data?.SystemInformationReadUnique) {
      dispatch({
        'type': 'SYSTEMINFO_LOCAL_UPDATE',
        'payload': _QueryLocalSystemInformation.data.SystemInformationReadUnique
      })
    }
  }, [_QueryLocalSystemInformation.data, _QueryLocalSystemInformation.error, dispatch])

  // Return null as this is just a handler.
  return null
}


/*
 *  Wraps both polling handlers
 */
const SystemInfoPollingProvider = ({ children }) => {
  // Return component.
  return (
    <>
      <RemoteSystemPollingHandler />
      <LocalSystemPollingHandler />
      {children}
    </>
  )
}


/*
 * EXPORTS
 */
export default SystemInfoPollingProvider
